export let history =[
    {
        "uuid":"AABB01",
        "Client":"RS Client Y",
        "Action":"Visit de proposition",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Planifiée",
           
    },
    {
        "uuid":"AABB02",
        "Client":"RS Client X",
        "Action":"Visit de garde de contact",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"En cours",
           
    },
    {
        "uuid":"AABB03",
        "Client":"RS Client Y",
        "Action":"Visit de garde de contact",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Reportée",
        "rapport" : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },
    {
        "uuid":"AABB04",
        "Client":"RS Client X",
        "Action":"Visit de proposition",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Planifiée",
        "rapport" : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },{
        "uuid":"AABB05",
        "Client":"RS Client Y",
        "Action":"Visit de proposition",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Effectuée",
        "rapport" : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
           
    }
    ,{
        "uuid":"AABB06",
        "Client":"RS Client X",
        "Action":"Visit de garde de contact",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Effectuée",
        "rapport" : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
           
    }
]